var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb')], 1)]), _c('b-card', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-4 mb-2 font-weight-bold"
  }, [_vm._v("短網址列表")]), _c('div', {
    staticClass: "\n          col-12 col-xl-6\n          d-flex\n          flex-xl-row\n          align-items-start align-items-xl-center\n        "
  }, [_vm.checkPermission([_vm.consts.SHORT_URL_CREATE]) ? _c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0 mr-3",
    attrs: {
      "variant": "primary",
      "to": {
        name: 'ShortUrlCreate'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("新增短網址")]) : _vm._e(), _c('b-input-group', [_c('b-form-input', {
    attrs: {
      "placeholder": "搜尋"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handlePageReset.apply(null, arguments);
      }
    },
    model: {
      value: _vm.query.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "keyword", $$v);
      },
      expression: "query.keyword"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": _vm.handlePageReset
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1)], 1)]), _c('b-card-text', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.shortUrls,
      "fields": _vm.fields
    },
    scopedSlots: _vm._u([{
      key: "cell(code)",
      fn: function fn(data) {
        return [_c('b-button', {
          directives: [{
            name: "b-modal",
            rawName: "v-b-modal",
            value: "modal-".concat(data.item.id),
            expression: "`modal-${data.item.id}`"
          }],
          staticClass: "mr-2",
          attrs: {
            "variant": "inverse-dark"
          }
        }, [_c('i', {
          staticClass: "fa fa-link mr-0"
        })]), _c('b-modal', {
          attrs: {
            "id": "modal-".concat(data.item.id)
          },
          scopedSlots: _vm._u([{
            key: "modal-header",
            fn: function fn(_ref) {
              var close = _ref.close;
              return [_c('h5', {
                staticClass: "m-0 align-self-center"
              }, [_vm._v(" " + _vm._s(data.item.title) + " ")]), _c('b-button', {
                staticClass: "text-dark",
                attrs: {
                  "size": "sm",
                  "variant": "link"
                },
                on: {
                  "click": function click($event) {
                    return close();
                  }
                }
              }, [_c('svg', {
                staticStyle: {
                  "height": "20px"
                },
                attrs: {
                  "xmlns": "http://www.w3.org/2000/svg",
                  "viewBox": "0 0 320 512"
                }
              }, [_c('path', {
                attrs: {
                  "d": "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                }
              })])])];
            }
          }, {
            key: "modal-footer",
            fn: function fn() {
              return [_c('div', {
                staticClass: "modal-button-group"
              }, [_c('b-button', {
                staticClass: "center-button",
                attrs: {
                  "variant": "primary"
                },
                on: {
                  "click": function click($event) {
                    return _vm.downloadQRCode(data.item.title);
                  }
                }
              }, [_vm._v(" 下載QRCode ")]), _c('b-button', {
                attrs: {
                  "variant": "danger"
                },
                on: {
                  "click": function click($event) {
                    return _vm.$bvModal.hide("modal-".concat(data.item.id));
                  }
                }
              }, [_vm._v(" 關閉 ")])], 1)];
            },
            proxy: true
          }], null, true)
        }, [_c('div', {
          staticClass: "d-flex flex-column align-items-center"
        }, [_c('b-form-input', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.click",
            modifiers: {
              "click": true
            }
          }],
          attrs: {
            "value": "".concat(_vm.shortUrlHost, "/").concat(data.item.code),
            "title": "已複製"
          },
          on: {
            "click": function click($event) {
              return _vm.clipboard("".concat(_vm.shortUrlHost, "/").concat(data.item.code));
            },
            "focus": function focus($event) {
              return $event.target.select();
            }
          }
        }), _c('div', [_c('vue-qr', {
          ref: "qrcode",
          attrs: {
            "text": "".concat(_vm.shortUrlHost, "/").concat(data.item.code)
          }
        })], 1)], 1)]), _c('a', {
          attrs: {
            "target": "_blank",
            "href": "".concat(_vm.shortUrlHost, "/").concat(data.item.code)
          }
        }, [_vm._v(_vm._s("".concat(_vm.shortUrlHost, "/").concat(data.item.code)))])];
      }
    }, {
      key: "cell(url)",
      fn: function fn(data) {
        return [_c('div', [_vm._v(" " + _vm._s(data.item.url_type == "oa" ? "官方帳號" : data.item.url && data.item.url.slice(0, 40) + "...") + " ")])];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [_c('b-button', {
          attrs: {
            "variant": "inverse-primary",
            "to": {
              name: 'ShortUrlView',
              params: {
                short_url_id: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-eye"
        }), _vm._v(" 查看 ")]), _c('b-button', {
          attrs: {
            "variant": "inverse-warning",
            "to": {
              name: 'ShortUrlEdit',
              params: {
                short_url_id: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-lead-pencil"
        }), _vm._v(" 編輯 ")]), _c('b-button', {
          attrs: {
            "variant": "inverse-danger"
          },
          on: {
            "click": function click($event) {
              return _vm.deleteShortUrls(data.item);
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-delete"
        }), _vm._v(" 刪除 ")])];
      }
    }])
  })], 1)], 1)]), _c('CustomPagination', {
    attrs: {
      "currentPage": _vm.query.page,
      "totalRows": _vm.totalRows,
      "perPage": _vm.query.per_page
    },
    on: {
      "page-change": _vm.handlePageChange,
      "per-page-change": _vm.handlePerPageChange
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }